var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5764 11.6858L15.4168 21.8454L9.88225 16.3262L7.7085 18.5L15.4168 26.2083L27.7502 13.875L25.5764 11.6858ZM18.5002 3.08331C9.99016 3.08331 3.0835 9.98998 3.0835 18.5C3.0835 27.01 9.99016 33.9166 18.5002 33.9166C27.0102 33.9166 33.9168 27.01 33.9168 18.5C33.9168 9.98998 27.0102 3.08331 18.5002 3.08331ZM18.5002 30.8333C11.686 30.8333 6.16683 25.3141 6.16683 18.5C6.16683 11.6858 11.686 6.16665 18.5002 6.16665C25.3143 6.16665 30.8335 11.6858 30.8335 18.5C30.8335 25.3141 25.3143 30.8333 18.5002 30.8333Z",
    fill: "#3AB572"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check_green.f8dc399aeacf2508c800762fce08f9f1.svg";
export { ForwardRef as ReactComponent };